import React, { useState, useEffect } from 'react';
import { Utils } from 'Utils/utils';
import { MX_EVENTS_AE, SALESGEAR_URL } from 'Utils/constants';
import AdaptBlueLogo from 'Assets/logo/logo24.png';
import SalesIncImg from 'Assets/salesgear/png/aeContactUpgrade.png';
import BgDottedImg from 'Assets/salesgear/png/bgDotted.png';

const SalesgearUpgradePopup = props => {
  const { hide, value } = props;
  const [subTitle, setSubtitle] = useState('');

  const closePopup = () => {
    hide(false);
  };

  const getPopupText = () => {
    const { exportSuccess, name, count } = value || '';
    const contentObj = {};
    if (name && name === 'export') {
      contentObj.text =
        'Upgrade your Salesgear account and<br> export unlimited contacts';
      contentObj.title = 'Contact limit reached';
      contentObj.countText = `<span>${exportSuccess} out of ${count} contacts</span> successfully exported to Salesgear.`;
    } else {
      contentObj.text =
        'You have hit the limit of 100 contacts in the free plan.';
      contentObj.title = 'Upgrade to continue';
    }
    setSubtitle(contentObj);
  };

  const redirectToSalesgearPricing = () => {
    hide(false);
    Utils.mixpanelTrack(MX_EVENTS_AE.bannerClicked);
    // eslint-disable-next-line no-undef
    window.open(`${SALESGEAR_URL}/pricing`);
  };

  useEffect(() => {
    getPopupText();
  }, []);

  return (
    <>
      <div className="overlayMask" />
      <div className="salesgearBannerPopup">
        <div className="aeCard popupAnimate popupScaleIn">
          <div className="aeTitle">
            <i className="material-icons closePopup" onClick={closePopup}>
              close
            </i>
            <h4 className="aeProductName">
              <img src={AdaptBlueLogo} alt="" />
              <span className="text">Salesgear</span>
            </h4>
            <h4>{subTitle.title}</h4>
          </div>
          <div className="aeBody aeUpgradeBody">
            {subTitle.countText && (
              <p
                className="aeDescCount"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: subTitle.countText || '',
                }}
              />
            )}
            <p
              className="aeDesc"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: subTitle.text || '',
              }}
            />
            <div className="btnSection aeBtnSection">
              <button
                className="btnSalesgear aeUpgradeBtn wiggle"
                onClick={redirectToSalesgearPricing}
                type="button"
              >
                Upgrade Now
              </button>
              <p
                className={`aboutPolicy ${subTitle.countText ? 'pBtm30' : ''} `}
              >
                No Contracts. No Obligations.
                <br />
                Cancel Anytime.
              </p>
            </div>
            <img src={SalesIncImg} className="upgradeImg" alt="" />
            <img src={BgDottedImg} className="bgDotted" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesgearUpgradePopup;
